import { CsvHeader } from 'types'

export const TITLE = 'External Site Mapping'

export const BROWSE = 'Browse'
export const UPLOAD = 'Upload'

export const DOWNLOAD_RESULTS_LINK_LABEL = 'Download Results'
export const TOOL_DESCRIPTION = `For each row of the uploaded File, this tool will update the our map our sites with the external site id of a newly registered rostering site.`
export const FIELD_DESCRIPTION_SITE_ID =
  'The internal (SS) Id of the site having its external Site mapped'
export const FIELD_DESCRIPTION_EXTERNAL_SITE_ID =
  'The Id of the external site the SecondStep site is mapped to'
export const FIELD_DESCRIPTION_DISTRICT = 'The district of the SecondStep site'

export const csvTemplateHeaders: CsvHeader[] = [
  { label: 'SiteId', key: 'siteId' },
  { label: 'ExternalSiteId', key: 'externalSiteId' },
  { label: 'District', key: 'district' },
]
